(function () {
  var isInstalled = false;

  function installPrefetchGuard() {
    if (
      isInstalled ||
      !window.theme ||
      typeof window.theme.prefetchVariants !== 'function'
    ) {
      return;
    }

    var nativePrefetchVariants = window.theme.prefetchVariants;

    window.theme.prefetchVariants = function (context, prodForm, sectionId, config) {
      if (
        context &&
        context.classList &&
        context.classList.contains('sg-pdp-conversion') &&
        !context.dataset.sgVariantPrefetchEnabled
      ) {
        return;
      }

      return nativePrefetchVariants.call(this, context, prodForm, sectionId, config);
    };

    isInstalled = true;
  }

  installPrefetchGuard();

  if (!isInstalled) {
    document.addEventListener('DOMContentLoaded', installPrefetchGuard, { once: true });
  }
})();
